import "core-js/modules/es6.symbol.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.array.iterator.js";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters } from 'vuex';
import UrlParse from 'url-parse';
import { EMPTY_PIXEL } from '~/const/images';
import { fetchArticlesByTag } from '~/services/editorial';
import { formatPrismicImage } from '~/helpers/image-helper';
import GlobalArticleCard from '~/components/molecules/Editorial/Global/GlobalArticleCard.vue';

var GlobalRichText = () => import(
/* webpackChunkName:"global-editorial" */
'~/components/atoms/Editorial/Global/GlobalRichText.vue');

export default {
  name: 'ChristmasCardBanner',
  components: {
    GlobalRichText,
    GlobalArticleCard
  },
  props: {
    payload: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      articles: []
    };
  },

  computed: _objectSpread(_objectSpread({}, mapGetters({
    locale: 'i18n/locale'
  })), {}, {
    currentPayload() {
      var _ref11, _ref12, _ref13, _ref14, _ref15, _ref17, _ref18, _ref19;

      return {
        background_color: ((_ref19 = this.payload) != null ? (_ref19 = _ref19.primary) != null ? _ref19.background_color : _ref19 : _ref19) || '',
        background_image: formatPrismicImage((_ref18 = this.payload) != null ? (_ref18 = _ref18.primary) != null ? (_ref18 = _ref18.background_image) != null ? _ref18.url : _ref18 : _ref18 : _ref18) || EMPTY_PIXEL,
        title: ((_ref17 = this.payload) != null ? (_ref17 = _ref17.primary) != null ? _ref17.title : _ref17 : _ref17) || [],
        tags: this.payload.items.map(i => {
          var _ref16;

          return ((_ref16 = i) != null ? _ref16.tags : _ref16) || '';
        }),
        button: {
          text: ((_ref15 = this.payload) != null ? (_ref15 = _ref15.primary) != null ? _ref15.button_text : _ref15 : _ref15) || '',
          url: new UrlParse(((_ref14 = this.payload) != null ? (_ref14 = _ref14.primary) != null ? (_ref14 = _ref14.button_url) != null ? _ref14.url : _ref14 : _ref14 : _ref14) || '').pathname,
          tracking: {
            data: {
              event_category: ((_ref13 = this.payload) != null ? (_ref13 = _ref13.primary) != null ? _ref13.event_category : _ref13 : _ref13) || '',
              event_action: ((_ref12 = this.payload) != null ? (_ref12 = _ref12.primary) != null ? _ref12.event_action : _ref12 : _ref12) || '',
              event_label: ((_ref11 = this.payload) != null ? (_ref11 = _ref11.primary) != null ? _ref11.event_label : _ref11 : _ref11) || ''
            }
          }
        }
      };
    }

  }),

  created() {
    var _this = this;

    return _asyncToGenerator(function* () {
      var articles = yield fetchArticlesByTag(_this.$store, {
        tags: _this.currentPayload.tags
      });
      _this.articles = articles.results.slice(0, 3).map(e => {
        var _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10;

        return {
          slug: e.slugs[0],
          tags: ((_ref10 = e) != null ? _ref10.tags : _ref10) || [],
          date: ((_ref9 = e) != null ? (_ref9 = _ref9.data) != null ? _ref9.date : _ref9 : _ref9) || '',
          title: ((_ref8 = e) != null ? (_ref8 = _ref8.data) != null ? (_ref8 = _ref8.main_title) != null ? (_ref8 = _ref8[0]) != null ? _ref8.text : _ref8 : _ref8 : _ref8 : _ref8) || '',
          difficulty: ((_ref7 = e) != null ? (_ref7 = _ref7.data) != null ? _ref7.difficulty : _ref7 : _ref7) || 0,
          readingTime: ((_ref6 = e) != null ? (_ref6 = _ref6.data) != null ? _ref6.reading_time : _ref6 : _ref6) || 0,
          image: {
            small: formatPrismicImage((_ref5 = e) != null ? (_ref5 = _ref5.data) != null ? (_ref5 = _ref5.image) != null ? (_ref5 = _ref5.small) != null ? _ref5.url : _ref5 : _ref5 : _ref5 : _ref5) || EMPTY_PIXEL,
            large: formatPrismicImage((_ref4 = e) != null ? (_ref4 = _ref4.data) != null ? (_ref4 = _ref4.image) != null ? (_ref4 = _ref4.large) != null ? _ref4.url : _ref4 : _ref4 : _ref4 : _ref4) || EMPTY_PIXEL
          },
          tracking: {
            data: {
              event_category: ((_ref3 = _this.payload) != null ? (_ref3 = _ref3.primary) != null ? _ref3.event_category : _ref3 : _ref3) || '',
              event_action: ((_ref2 = _this.payload) != null ? (_ref2 = _ref2.primary) != null ? _ref2.event_action : _ref2 : _ref2) || '',
              event_label: ((_ref = e) != null ? (_ref = _ref.data) != null ? (_ref = _ref.main_title) != null ? (_ref = _ref[0]) != null ? _ref.text : _ref : _ref : _ref : _ref) || ''
            }
          }
        };
      });
    })();
  }

};